@if (bonusSelection()) {
  @if (currentProductAlreadyOrdered()) {
    <app-general-warning
      *appApplyIfNotEmpty="translationService.getTranslation('currentProduct.alreadyOrdered')"
      [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]">
    </app-general-warning>
  }
  <form [formGroup]="bonusFormGroup" class="mt-3 offer-detail__form offer-detail__form--bonus">
    <div class="container-fluid p-0 offer-detail__bonus-container">
      <div class="row offer-detail__row offer-detail__row--bonus">
        <div class="col-12 offer-detail__bonus-list">
          <div id="bonusCard" class="offer-detail__bonus-card">
            <!-- Prämien auflisten -->
            <div class="row offer-detail__row offer-detail__row--bonus-cards">
              @for (bonus of bonuses(); track bonus; let i = $index) {
                @if (i < maxBonuses) {
                  <div [className]=" 'mb-3 ' +
                                        'col-' + (CssPropertiesEnum.bonusFxFlex|cssProperty: vHostService) + ' ' +
                                        'col-sm-' + (CssPropertiesEnum.bonusFxFlexSM|cssProperty: vHostService) + ' ' +
                                        'col-md-' + (CssPropertiesEnum.bonusFxFlexMD|cssProperty: vHostService) + ' ' +
                                        'col-lg-' + (CssPropertiesEnum.bonusFxFlexLG|cssProperty: vHostService) + ' ' +
                                        'col-xl-' + (CssPropertiesEnum.bonusFxFlexXL|cssProperty: vHostService) + ' ' +
                                        'col-xxl-' + (CssPropertiesEnum.bonusFxFlexXXL|cssProperty: vHostService) + ' offer-detail__bonus-card-item'">
                    <mat-card appearance="outlined"
                              class="pointer h-100 offer-detail__bonus-card-content"
                              [ngClass]="bonus.selected ? 'selectedBonus' : 'unselectedBonus'">
                      <mat-card-header class="offer-detail__bonus-card-header">
                        <mat-card-title class="pb-0 offer-detail__bonus-card-title"
                                        (click)="onSelectBonus(bonus, bonusNextButton)">
                          <div>{{ bonus.name }}</div>
                        </mat-card-title>
                      </mat-card-header>
                      <div class="bonusBody h-100 offer-detail__bonus-card-body">
                        @if (bonus.image) {
                          <img mat-card-image class="mw-100 offer-detail__bonus-card-img"
                               [ngSrc]="bonus.image.src"
                               [width]="imageService.width"
                               [height]="imageService.height"
                               [priority]="true"
                               [alt]="bonus.image.altText"
                               (click)="onSelectBonus(bonus, bonusNextButton)">
                        }
                      </div>
                      <div class="footer row offer-detail__bonus-card-footer">
                        <div class="col-12 col-sm-6 text-center">
                          <button class="detailBonusButton btn btn-secondary m-2 offer-detail__bonus-details-btn"
                                  mat-flat-button color="primary"
                                  (click)="onShowDetails(bonus)"
                                  data-cy="btn-show-bonus-details"
                                  [innerHTML]="translationService.getTranslation('button_details')"></button>
                        </div>
                        <div class="col-12 col-sm-6 text-center">
                          <button class="selectBonusButton m-2 offer-detail__bonus-select-btn" mat-raised-button
                                  color="primary"
                                  (click)="onSelectBonus(bonus, bonusNextButton)"
                                  data-cy="btn-select-bonus"
                                  [innerHTML]="translationService.getTranslation('button_bonus_select')"></button>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                }
              }
            </div>
          </div>
        </div>
        @if (bonuses().length > maxBonuses) {
          <div class="col-12 mt-3 mb-5 text-center offer-detail__bonus-more">
            <button mat-raised-button color="primary"
                    (click)="loadMoreBonuses()"
                    [innerHTML]="translationService.getTranslation('button_more_bonuses')"></button>
          </div>
        }
      </div>
    </div>
    <div class="col-12 mt-1 offer-detail__bonus-selected-list">
      @if (selectedBonus.length > 0) {
        <div class="col-12 mt-5 offer-detail__bonus-selected"
             [innerHTML]="translationService.getTranslation('bonus_selected')"></div>
        @for (bonus of getBonusControls(); track bonus; let i = $index) {
          <div class="offer-detail__bonus-selected-item">
            <mat-checkbox (click)="onDeselectBonus(i)" checked="checked"
                          class="text-wrap offer-detail__bonus-selected-checkbox">
              <div [innerHTML]="bonus.value.name"></div>
            </mat-checkbox>
          </div>
        }
      }

      @if (!selectedBonus) {
        <div class="col-12 mt-5 offer-detail__bonus-missing"
             [innerHTML]="translationService.getTranslation('offer.missingBonus')"></div>
      }
      <div class="text-end mt-1 offer-detail__next-btn offer-detail__next-btn--bonus" #bonusNextButton>
      </div>
    </div>

    <!-- Prämienadresse: der Besteller erhält die Sachprämie.
         Werden ausschließlich Sachprämien angeboten, steht schon vor der Auswahl fest, dass eine
         Prämienadresse gebraucht wird - dann erscheint der Block sofort. Bei gemischten
         Prämienarten erst, sobald eine Sachprämie gewählt ist (s. showBonusAddressBlock). -->
    @if (showBonusAddressBlock()) {
      @if (bonusAddressTarget()) {
        <!-- Es liegt bereits eine Adresse vor: zeigen, wohin die Prämie geht, und die
             Änderung über "Abweichende Prämienadresse" anbieten. -->
        <mat-card class="offer-detail__bonus-target" data-cy="bonus-address-target">
          <mat-card-header>
            <mat-card-title
              [innerHTML]="bonusAddressTitle()"></mat-card-title>
          </mat-card-header>
          <div class="offer-detail__bonus-target-body">
            @for (line of bonusAddressTargetLines(); track $index) {
              <div>{{ line }}</div>
            }
          </div>
        </mat-card>
      }
      @if (showBonusAddressForm()) {
        <app-hup-subscription-address
          [showActivateCheckbox]="!!bonusAddressTarget()"
          [addressType]="bonusAddressTarget() ? '' : bonusAddressTitle()"
          [askForPhone]="askForPhone"
          [isPhoneRequired]="askForPhone && isPhoneRequired"
          [controlGroup]="bonusAddressGroup"
          [activateCheckboxText]="bonusDifferentAddressKey()"
          class="offer-detail__address-component offer-detail__address-component--bonus">
        </app-hup-subscription-address>
      }
    }

    <!-- Werberadresse: der Werber erhält die Prämie (Leser werben Leser) -->
    @if (showAdvertiserAddressBlock()) {
      <app-hup-subscription-address
        [showActivateCheckbox]="false"
        [askForBirthday]="false"
        [askForEmail]="false"
        [controlGroup]="advertiserAddressGroup"
        [addressType]="translationService.getTranslation('address_advertiser')">
      </app-hup-subscription-address>
    }

    <!-- Zuzahlung: erscheint erst, wenn eine gewählte Prämie sie verlangt -->
    @if (nonMoneyBonusWithClientCoPaymentSelected) {
      <app-general-warning
        [warnings]="[{infoText: translationService.getTranslation('bonus.co-payment.notification')}]"
        class="offer-detail__bonus-copayment-warning">
      </app-general-warning>
    }

    <!-- Zahldaten: für die Auszahlung einer Geldprämie und für die Zuzahlung einer Sachprämie -->
    @if (moneyBonusSelected || nonMoneyBonusWithClientCoPaymentSelected) {
      <div formGroupName="payment">
        <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--iban-bonus">
          <mat-label>{{ translationService.getTranslation('payment_iban_bonus') }}</mat-label>
          <input maxlength="34" matInput formControlName="ibanBonus"
                 [value]="bonusFormGroup.get('payment.ibanBonus').value"
                 oninput="this.value = this.value.toUpperCase()" #ibanBonus>
          @if (ibanBonus === document?.activeElement && ibanBonus.value.length >= 1) {
            <mat-hint align="end">{{ ibanBonus.value.length }} / {{ ibanBonus.maxLength }}</mat-hint>
          }
          @if (bonusFormGroup.get('payment.ibanBonus').hasError('message')) {
            <mat-error class="offer-detail__error"
            >{{ bonusFormGroup.get('payment.ibanBonus').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        @if (bonusFormGroup.get('payment.ibanBonus').status === 'PENDING') {
          <div class="offer-detail__iban-bonus-spinner">
            <app-loading-spinner [type]="'small'"></app-loading-spinner>
          </div>
        }
        <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--bic-bonus">
          <mat-label>{{ translationService.getTranslation('payment_bic_bonus') }}</mat-label>
          <input matInput formControlName="bicBonus" [value]="bonusFormGroup.get('payment.bicBonus').value">
          @if (bonusFormGroup.get('payment.bicBonus').hasError('message')) {
            <mat-error class="offer-detail__error"
            >{{ bonusFormGroup.get('payment.bicBonus').getError('message') }}
            </mat-error>
          }
        </mat-form-field>

        @if (askForPaymentHolder) {
          <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--account-holder-bonus">
            <mat-label [innerHTML]="translationService.getTranslation('payment_holder')"></mat-label>
            <input matInput minlength="1" maxlength="255" formControlName="accountHolderBonus"
                   [value]="bonusFormGroup.get('payment.accountHolderBonus').value" data-cy="input-bic"
                   #accountHolderBonus>
            @if (accountHolderBonus === document?.activeElement && accountHolderBonus.value.length >= 1) {
              <mat-hint align="end">{{ accountHolderBonus.value.length }}/ {{ accountHolderBonus.maxLength }}
              </mat-hint>
            }
            @if (bonusFormGroup.get('payment.accountHolderBonus').hasError('message')) {
              <mat-error>{{ bonusFormGroup.get('payment.accountHolderBonus').getError('message') }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
    }
  </form>

  <!-- Navigationselemente -->
  <div class="text-end mt-1 offer-detail__next-btn offer-detail__next-btn--payment">
    @if (!isAuthenticated()) {
      <button type="button" class="me-3 offer-detail__back-btn offer-detail__back-btn--bonus" mat-raised-button
              matStepperPrevious
              [innerHTML]="translationService.getTranslation('button_back')"></button>
    }
    <button type="submit" align="end" mat-raised-button color="primary" data-cy="btn-bonus-next"
            (click)="parentStepper.next()"
            [innerHTML]="translationService.getTranslation('button_next')">
    </button>
  </div>
}
